import React, { useState, useEffect, useContext } from "react";
import {
    PaymentElement,
    useStripe,
    useElements,
    AddressElement,
    LinkAuthenticationElement,
} from "@stripe/react-stripe-js";
import { axiosSC, axiosSW, axiosSW2 } from "../../api/axiosDefaults";
import styles from "./styles/Search.module.css";
import "./styles/stripe.css";
import Button from "../../components/ui/button/Button";
import NavButton from "../../components/ui/navbutton/NavButton";
import DataContext from "../../context/DataContext";
import PaymentFormWindow from "./PaymentFormWindow";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { env } from "../../env";
import useAuthReady from "../../hooks/useAuthReady";

/**
 * PaymentForm component
 * The paying process order is as folows:
 * handle submit => insertPaymentData => handleCapture => updatePayment => navigate to result page
 */
const PaymentForm = ({
    totalAmount, // {Float} - Total amount to be paid.
    description, // {String} - Payment description.
    setShowPaymentForm, // {Function} - Set payment form visibility function.
    uniqueID, // {String} - Unique client identifier.
    ticketsNumbers, // {Array} - Array of ticket numbers.
    windowContent, // {Object} - Window content object.
    paymentIntentID, // {String} - Payment intent ID.
    instalmentsId,
    administrative,
    clientSecret,
}) => {
    const { t } = useTranslation();
    const {
        connection, // {Object} - Current client's settings.
        homePath, // {String} - Home path.
        handleError, // {Function} - Error handling function.
        setResult, // {Function} - Set result function.
        setIsValidSearch, // {Function} - Set search validity function.
    } = useContext(DataContext);
    const stripe = useStripe();
    const elements = useElements();
    const [stripeError, setStripeError] = useState(null); // A stripe functional related error (stripe server error)
    const [minorError, setMinorError] = useState(null); // A stripe user related error (user input validation)
    const [success, setSuccess] = useState(false);
    const [timeLeft, setTimeLeft] = useState(5 * 60); // 5 minutes in seconds

    // const [inProcess, setInProcess] = useState(false); //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! testing
    const [PaymnetInProcess, setPaymnetInProcess] = useState(false);
    const navigate = useNavigate();
    const { bUser } = useParams();

    /**
     * Set focus on creditcard number field and set success to true
     */
    const initilaizeElement = (event) => {
        setSuccess(true);
        event.focus();
    };

    // Cancel payment on page refresh or close,
    // fetch is used instead of axios for this functionality
    // to insure the request is sent before the page is closed
    useEffect(() => {
        const handleBeforeUnload = async (event) => {
            // event.preventDefault(); // This will show a dialog box in most browsers

            event.returnValue = ""; // This is required for Chrome
            // const token = JSON.parse(localStorage.getItem("JWTToken"));
            let token = null;
            try {
                token = JSON.parse(localStorage.getItem("JWTToken"));
            } catch (error) {
                console.log("Corrupted Token", error);
            }

            if (!token) {
                console.warn("No JWT token available for payment cancellation");
                return;
            }
            const data = {
                paymentIntentId: paymentIntentID,
                customerId: connection?.uniqueId,
                cancelReason: "Customer requested cancellation",
            };

            fetch(`${env.REACT_APP_SCHWEERS_API_URL_2}/payments/cancel`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",

                    ...(token && { Authorization: `Bearer ${token}` }),
                },
                body: JSON.stringify(data),
                keepalive: true,
            });
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Cleanup function to remove the event listener
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [paymentIntentID]);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    handleRelease(paymentIntentID);
                    setShowPaymentForm(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [setShowPaymentForm]);

    /**
     * Form close handle
     */
    const handleClose = () => {
        handleRelease(paymentIntentID); // cancel the reservation and release the amount
        setShowPaymentForm(false);
    };

    /**
     * Stripe payment release handle
     * Used to release the amount that was captured on error or cancel
     * Through SC server
     * axiosSC
     */
    const handleRelease = async (paymentIntentID) => {
        try {
            const { data } = await axiosSW2.post("/payments/cancel", {
                paymentIntentId: paymentIntentID,
                customerId: connection?.uniqueId,

                cancelReason: "Customer requested cancellation",
            });
        } catch (error) {
            setPaymnetInProcess(false);
            setStripeError(error.message);
        }
    };

    // /**
    //  * Cancel the payment on error
    //  * Through schweers API
    //  * and redirect to the result page
    //  * axiosSW
    //  */
    // const cancelPayment = async (message) => {
    //     try {
    //         const response = await axiosSW.post(
    //             "Payments/payment/SetPaymentTransactionCancelled",
    //             {
    //                 uniqueID: uniqueID,
    //                 paymentIntentID: paymentIntentID,
    //                 cancelMessage: message,
    //             },
    //         );

    //         setIsValidSearch(false);
    //         setResult({
    //             error: response,
    //             errorMessage: response?.data.statusMessage,
    //         });
    //         setPaymnetInProcess(false);
    //         navigate(`/${bUser}/result`);
    //     } catch (error) {
    //         setPaymnetInProcess(false);
    //         handleError(error);
    //     }
    // };

    /**
     * Update the payment data on successfull payment
     * Through schweers API
     * axiosSW
     */
    const paymentAccept = async () => {
        try {
            const { data } = await axiosSW2.put("/payments/accept", {
                customerId: connection?.uniqueId,
                paymentIntentID: paymentIntentID,
                ticketNumbers: ticketsNumbers,
                // amount: totalAmount,
                // currency: connection?.currencyCode,
                // fee: fee,
                // feeCurrency: feeCurrency,
                // cardBrand:
                //     charge?.payment_method_details?.card?.brand ?? "unknown",
                // last4CardDigits: last4Digits,
            });

            setResult({
                last4CreditCardDigits: data?.last4CardDigits,
                paymentIntentID: paymentIntentID,
                paidNow: true,
                statusOk: true,
            });

            setIsValidSearch(false);
            setPaymnetInProcess(false);
            setShowPaymentForm(false);
            navigate(`/${bUser}/result`);
        } catch (error) {
            setPaymnetInProcess(false);
            handleError(error);
        }
    };

    /**
     * Submit handle
     */
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            console.log("Stripe.js has not loaded yet.");
            return;
        }
        setPaymnetInProcess(true);
        // const card = elements.getElement(PaymentElement);

        try {
            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: window.location.href,
                },
                redirect: "if_required",
            });

            /**
             * Case of card errors, the error is handled as minor error and it will be displayed
             * in the PaymentForm other wise it will be handled as a stripe error
             * A minor error can be card number incorrect or date incorrect and the user can update it and resubmit
             * A stripe error is a server error and the user can't do anything about it
             * it will be displayed in the PaymentFormWindow and the user can only go back to search
             */
            if (error) {
                setPaymnetInProcess(false);
                error.type === "StripeCardError" ||
                error.type === "validation_error"
                    ? setMinorError(error.message)
                    : setStripeError(error.message);
            } else if (paymentIntent.status === "succeeded") {
                setMinorError(null);
                setStripeError(null);
                // setInProcess(true);

                paymentAccept();
                // insertPaymentData();
            }
        } catch (error) {
            setPaymnetInProcess(false);
            setStripeError(error.message);
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className={`${styles.pay_form} v-flex-container`}
        >
            <div className={`${styles.pay_form_window_container}`}>
                <PaymentFormWindow
                    client
                    timeLeft={timeLeft}
                    description={description}
                    windowContent={windowContent}
                    minorError={minorError}
                    stripeError={stripeError}
                    // inProcess={inProcess}
                    success={success}
                    clientSecret={clientSecret}
                    PaymnetInProcess={PaymnetInProcess}
                />
            </div>
            {!stripeError ? (
                <div
                    className={`${styles.stripe_element_container} ${
                        !success ? "hidden" : ""
                    }`}
                >
                    <LinkAuthenticationElement />
                    <AddressElement
                        options={{
                            mode: "billing",
                            fields: {
                                phone: "always",
                            },
                            validation: {
                                phone: {
                                    required: "never",
                                },
                            },
                        }}
                    />
                    <PaymentElement
                        onReady={(event) => initilaizeElement(event)}
                    />

                    <div
                        className={`${styles.stripe_element_buttons_container} flex-container`}
                    >
                        <Button
                            body={t(`authorize payment`)}
                            type={"submit"}
                            disableHTML={!stripe || PaymnetInProcess}
                            disabled={!stripe || PaymnetInProcess}
                        />
                        <Button
                            body={t(`cancel`)}
                            type={"button"}
                            onClickFuction={() => handleClose(paymentIntentID)}
                            lightFontColor={true}
                            disableHTML={PaymnetInProcess}
                            disabled={PaymnetInProcess}
                            color={"red"}
                        />
                    </div>
                </div>
            ) : (
                // If there is a stripe error show the back to search button
                <div>
                    <NavButton body={t("back to search")} link={homePath} />
                </div>
            )}
        </form>
    );
};

export default PaymentForm;
